module.exports = __webpack_public_path__ + "static/img/gift-1.cadcca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-1.png
// module id = 353
// module chunks = 140